import StatusIcon from "@redotech/redo-icons/status.svg";
import { FulfillmentGroupStatus } from "@redotech/redo-model/fulfillments/fulfillment-group-status";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { fgFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { AdvancedFilterData } from "@redotech/redo-model/views/views";
import {
  AdvancedTableFilter,
  ArrayStringTableFilter,
} from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.status;

export const statusFilterName = "status" as const;

export const StatusArrayFilter = (
  fetcher: (
    { filters }: { filters: AdvancedTableFilter[] },
    signal: AbortSignal,
  ) => Promise<string[]>,
): ArrayStringTableFilter<string> => ({
  type: entry.type,
  Icon: StatusIcon,
  operators: [...entry.operators],
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "status",
  itemLabelPlural: "statuses",
  display: (item: string) => {
    return item
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  },
  displayName: entry.displayName,
  valueFetcher: fetcher,
});

export const statusShouldBeIncluded = (
  status: FulfillmentGroupStatus,
  statusFilters: Array<
    AdvancedFilterData & {
      name: ReturnType<typeof StatusArrayFilter>["data"]["name"];
    }
  >,
) => {
  let shouldBeIncluded = false;
  let relevantAnyOfFound = false;

  for (const statusFilter of statusFilters) {
    if (!statusFilter.value || (statusFilter.value as string[]).length === 0) {
      continue;
    }

    const rawStatusValues = (statusFilter.value as string[]).map(
      (displayName: string) => displayName.replace(/\s+/g, "_").toUpperCase(),
    );

    if (statusFilter.operator === ArrayStringFilterOperator.ANY_OF) {
      if (rawStatusValues.length > 0) {
        relevantAnyOfFound = true;
      }
      shouldBeIncluded = rawStatusValues.includes(status);
    } else if (
      statusFilter.operator === ArrayStringFilterOperator.NONE_OF &&
      rawStatusValues.includes(status)
    ) {
      return false;
    }
  }
  return !relevantAnyOfFound || shouldBeIncluded;
};
